/**
 * Auto-generated timezones dataset — DO NOT EDIT MANUALLY.
 * Generated: 2026-07-14T15:38:23.354Z
 */

import type { ITimezone } from '../types';

export const TIMEZONES: ITimezone[] = [
  {
    "name": "Asia/Kabul",
    "offset": 16200,
    "offset_name": "UTC+04:30",
    "abbreviation": "AFT",
    "tzName": "Afghanistan Time",
    "countryCode": "AF"
  },
  {
    "name": "Europe/Mariehamn",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "AX"
  },
  {
    "name": "Europe/Tirane",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "AL"
  },
  {
    "name": "Africa/Algiers",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "DZ"
  },
  {
    "name": "Pacific/Pago_Pago",
    "offset": -39600,
    "offset_name": "UTC-11:00",
    "abbreviation": "SST",
    "tzName": "Samoa Standard Time",
    "countryCode": "AS"
  },
  {
    "name": "Europe/Andorra",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "AD"
  },
  {
    "name": "Africa/Luanda",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WAT",
    "tzName": "West Africa Time",
    "countryCode": "AO"
  },
  {
    "name": "America/Anguilla",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "AI"
  },
  {
    "name": "Antarctica/Casey",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "AWST",
    "tzName": "Australian Western Standard Time",
    "countryCode": "AQ"
  },
  {
    "name": "Antarctica/Davis",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "DAVT",
    "tzName": "Davis Time",
    "countryCode": "AQ"
  },
  {
    "name": "Antarctica/DumontDUrville",
    "offset": 36000,
    "offset_name": "UTC+10:00",
    "abbreviation": "DDUT",
    "tzName": "Dumont d'Urville Time",
    "countryCode": "AQ"
  },
  {
    "name": "Antarctica/Mawson",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "MAWT",
    "tzName": "Mawson Station Time",
    "countryCode": "AQ"
  },
  {
    "name": "Antarctica/McMurdo",
    "offset": 46800,
    "offset_name": "UTC+13:00",
    "abbreviation": "NZDT",
    "tzName": "New Zealand Daylight Time",
    "countryCode": "AQ"
  },
  {
    "name": "Antarctica/Palmer",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "CLST",
    "tzName": "Chile Summer Time",
    "countryCode": "AQ"
  },
  {
    "name": "Antarctica/Rothera",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "ROTT",
    "tzName": "Rothera Research Station Time",
    "countryCode": "AQ"
  },
  {
    "name": "Antarctica/Syowa",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "SYOT",
    "tzName": "Showa Station Time",
    "countryCode": "AQ"
  },
  {
    "name": "Antarctica/Troll",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "AQ"
  },
  {
    "name": "Antarctica/Vostok",
    "offset": 21600,
    "offset_name": "UTC+06:00",
    "abbreviation": "VOST",
    "tzName": "Vostok Station Time",
    "countryCode": "AQ"
  },
  {
    "name": "America/Antigua",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "AG"
  },
  {
    "name": "America/Argentina/Buenos_Aires",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "ART",
    "tzName": "Argentina Time",
    "countryCode": "AR"
  },
  {
    "name": "America/Argentina/Catamarca",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "ART",
    "tzName": "Argentina Time",
    "countryCode": "AR"
  },
  {
    "name": "America/Argentina/Cordoba",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "ART",
    "tzName": "Argentina Time",
    "countryCode": "AR"
  },
  {
    "name": "America/Argentina/Jujuy",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "ART",
    "tzName": "Argentina Time",
    "countryCode": "AR"
  },
  {
    "name": "America/Argentina/La_Rioja",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "ART",
    "tzName": "Argentina Time",
    "countryCode": "AR"
  },
  {
    "name": "America/Argentina/Mendoza",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "ART",
    "tzName": "Argentina Time",
    "countryCode": "AR"
  },
  {
    "name": "America/Argentina/Rio_Gallegos",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "ART",
    "tzName": "Argentina Time",
    "countryCode": "AR"
  },
  {
    "name": "America/Argentina/Salta",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "ART",
    "tzName": "Argentina Time",
    "countryCode": "AR"
  },
  {
    "name": "America/Argentina/San_Juan",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "ART",
    "tzName": "Argentina Time",
    "countryCode": "AR"
  },
  {
    "name": "America/Argentina/San_Luis",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "ART",
    "tzName": "Argentina Time",
    "countryCode": "AR"
  },
  {
    "name": "America/Argentina/Tucuman",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "ART",
    "tzName": "Argentina Time",
    "countryCode": "AR"
  },
  {
    "name": "America/Argentina/Ushuaia",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "ART",
    "tzName": "Argentina Time",
    "countryCode": "AR"
  },
  {
    "name": "Asia/Yerevan",
    "offset": 14400,
    "offset_name": "UTC+04:00",
    "abbreviation": "AMT",
    "tzName": "Armenia Time",
    "countryCode": "AM"
  },
  {
    "name": "America/Aruba",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "AW"
  },
  {
    "name": "Antarctica/Macquarie",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "MIST",
    "tzName": "Macquarie Island Station Time",
    "countryCode": "AU"
  },
  {
    "name": "Australia/Adelaide",
    "offset": 37800,
    "offset_name": "UTC+10:30",
    "abbreviation": "ACDT",
    "tzName": "Australian Central Daylight Saving Time",
    "countryCode": "AU"
  },
  {
    "name": "Australia/Brisbane",
    "offset": 36000,
    "offset_name": "UTC+10:00",
    "abbreviation": "AEST",
    "tzName": "Australian Eastern Standard Time",
    "countryCode": "AU"
  },
  {
    "name": "Australia/Broken_Hill",
    "offset": 37800,
    "offset_name": "UTC+10:30",
    "abbreviation": "ACDT",
    "tzName": "Australian Central Daylight Saving Time",
    "countryCode": "AU"
  },
  {
    "name": "Australia/Currie",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "AEDT",
    "tzName": "Australian Eastern Daylight Saving Time",
    "countryCode": "AU"
  },
  {
    "name": "Australia/Darwin",
    "offset": 34200,
    "offset_name": "UTC+09:30",
    "abbreviation": "ACST",
    "tzName": "Australian Central Standard Time",
    "countryCode": "AU"
  },
  {
    "name": "Australia/Eucla",
    "offset": 31500,
    "offset_name": "UTC+08:45",
    "abbreviation": "ACWST",
    "tzName": "Australian Central Western Standard Time (Unofficial)",
    "countryCode": "AU"
  },
  {
    "name": "Australia/Hobart",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "AEDT",
    "tzName": "Australian Eastern Daylight Saving Time",
    "countryCode": "AU"
  },
  {
    "name": "Australia/Lindeman",
    "offset": 36000,
    "offset_name": "UTC+10:00",
    "abbreviation": "AEST",
    "tzName": "Australian Eastern Standard Time",
    "countryCode": "AU"
  },
  {
    "name": "Australia/Lord_Howe",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "LHST",
    "tzName": "Lord Howe Summer Time",
    "countryCode": "AU"
  },
  {
    "name": "Australia/Melbourne",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "AEDT",
    "tzName": "Australian Eastern Daylight Saving Time",
    "countryCode": "AU"
  },
  {
    "name": "Australia/Perth",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "AWST",
    "tzName": "Australian Western Standard Time",
    "countryCode": "AU"
  },
  {
    "name": "Australia/Sydney",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "AEDT",
    "tzName": "Australian Eastern Daylight Saving Time",
    "countryCode": "AU"
  },
  {
    "name": "Europe/Vienna",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "AT"
  },
  {
    "name": "Asia/Baku",
    "offset": 14400,
    "offset_name": "UTC+04:00",
    "abbreviation": "AZT",
    "tzName": "Azerbaijan Time",
    "countryCode": "AZ"
  },
  {
    "name": "Asia/Bahrain",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "AST",
    "tzName": "Arabia Standard Time",
    "countryCode": "BH"
  },
  {
    "name": "Asia/Dhaka",
    "offset": 21600,
    "offset_name": "UTC+06:00",
    "abbreviation": "BDT",
    "tzName": "Bangladesh Standard Time",
    "countryCode": "BD"
  },
  {
    "name": "America/Barbados",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "BB"
  },
  {
    "name": "Europe/Minsk",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "MSK",
    "tzName": "Moscow Time",
    "countryCode": "BY"
  },
  {
    "name": "Europe/Brussels",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "BE"
  },
  {
    "name": "America/Belize",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "BZ"
  },
  {
    "name": "Africa/Porto-Novo",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WAT",
    "tzName": "West Africa Time",
    "countryCode": "BJ"
  },
  {
    "name": "Atlantic/Bermuda",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "BM"
  },
  {
    "name": "Asia/Thimphu",
    "offset": 21600,
    "offset_name": "UTC+06:00",
    "abbreviation": "BTT",
    "tzName": "Bhutan Time",
    "countryCode": "BT"
  },
  {
    "name": "America/La_Paz",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "BOT",
    "tzName": "Bolivia Time",
    "countryCode": "BO"
  },
  {
    "name": "America/Kralendijk",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "BQ"
  },
  {
    "name": "Europe/Sarajevo",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "BA"
  },
  {
    "name": "Africa/Gaborone",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "CAT",
    "tzName": "Central Africa Time",
    "countryCode": "BW"
  },
  {
    "name": "Europe/Oslo",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "BV"
  },
  {
    "name": "America/Araguaina",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "BRT",
    "tzName": "Brasília Time",
    "countryCode": "BR"
  },
  {
    "name": "America/Bahia",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "BRT",
    "tzName": "Brasília Time",
    "countryCode": "BR"
  },
  {
    "name": "America/Belem",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "BRT",
    "tzName": "Brasília Time",
    "countryCode": "BR"
  },
  {
    "name": "America/Boa_Vista",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AMT",
    "tzName": "Amazon Time (Brazil)[3",
    "countryCode": "BR"
  },
  {
    "name": "America/Campo_Grande",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AMT",
    "tzName": "Amazon Time (Brazil)[3",
    "countryCode": "BR"
  },
  {
    "name": "America/Cuiaba",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "BRT",
    "tzName": "Brasilia Time",
    "countryCode": "BR"
  },
  {
    "name": "America/Eirunepe",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "ACT",
    "tzName": "Acre Time",
    "countryCode": "BR"
  },
  {
    "name": "America/Fortaleza",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "BRT",
    "tzName": "Brasília Time",
    "countryCode": "BR"
  },
  {
    "name": "America/Maceio",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "BRT",
    "tzName": "Brasília Time",
    "countryCode": "BR"
  },
  {
    "name": "America/Manaus",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AMT",
    "tzName": "Amazon Time (Brazil)",
    "countryCode": "BR"
  },
  {
    "name": "America/Noronha",
    "offset": -7200,
    "offset_name": "UTC-02:00",
    "abbreviation": "FNT",
    "tzName": "Fernando de Noronha Time",
    "countryCode": "BR"
  },
  {
    "name": "America/Porto_Velho",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AMT",
    "tzName": "Amazon Time (Brazil)[3",
    "countryCode": "BR"
  },
  {
    "name": "America/Recife",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "BRT",
    "tzName": "Brasília Time",
    "countryCode": "BR"
  },
  {
    "name": "America/Rio_Branco",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "ACT",
    "tzName": "Acre Time",
    "countryCode": "BR"
  },
  {
    "name": "America/Santarem",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "BRT",
    "tzName": "Brasília Time",
    "countryCode": "BR"
  },
  {
    "name": "America/Sao_Paulo",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "BRT",
    "tzName": "Brasília Time",
    "countryCode": "BR"
  },
  {
    "name": "Indian/Chagos",
    "offset": 21600,
    "offset_name": "UTC+06:00",
    "abbreviation": "IOT",
    "tzName": "Indian Ocean Time",
    "countryCode": "IO"
  },
  {
    "name": "Asia/Brunei",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "BNT",
    "tzName": "Brunei Darussalam Time",
    "countryCode": "BN"
  },
  {
    "name": "Europe/Sofia",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "BG"
  },
  {
    "name": "Africa/Ouagadougou",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "BF"
  },
  {
    "name": "Africa/Bujumbura",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "CAT",
    "tzName": "Central Africa Time",
    "countryCode": "BI"
  },
  {
    "name": "Asia/Phnom_Penh",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "ICT",
    "tzName": "Indochina Time",
    "countryCode": "KH"
  },
  {
    "name": "Africa/Douala",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WAT",
    "tzName": "West Africa Time",
    "countryCode": "CM"
  },
  {
    "name": "America/Atikokan",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Blanc-Sablon",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "CA"
  },
  {
    "name": "America/Cambridge_Bay",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Creston",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Dawson",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Dawson_Creek",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Edmonton",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Fort_Nelson",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Glace_Bay",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "CA"
  },
  {
    "name": "America/Goose_Bay",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "CA"
  },
  {
    "name": "America/Halifax",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "CA"
  },
  {
    "name": "America/Inuvik",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Iqaluit",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "CA"
  },
  {
    "name": "America/Moncton",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "CA"
  },
  {
    "name": "America/Nipigon",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "CA"
  },
  {
    "name": "America/Pangnirtung",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "CA"
  },
  {
    "name": "America/Rainy_River",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Rankin_Inlet",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Regina",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Resolute",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/St_Johns",
    "offset": -12600,
    "offset_name": "UTC-03:30",
    "abbreviation": "NST",
    "tzName": "Newfoundland Standard Time",
    "countryCode": "CA"
  },
  {
    "name": "America/Swift_Current",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Thunder_Bay",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Toronto",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Vancouver",
    "offset": -28800,
    "offset_name": "UTC-08:00",
    "abbreviation": "PST",
    "tzName": "Pacific Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Whitehorse",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Winnipeg",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "America/Yellowknife",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "CA"
  },
  {
    "name": "Atlantic/Cape_Verde",
    "offset": -3600,
    "offset_name": "UTC-01:00",
    "abbreviation": "CVT",
    "tzName": "Cape Verde Time",
    "countryCode": "CV"
  },
  {
    "name": "America/Cayman",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "KY"
  },
  {
    "name": "Africa/Bangui",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WAT",
    "tzName": "West Africa Time",
    "countryCode": "CF"
  },
  {
    "name": "Africa/Ndjamena",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WAT",
    "tzName": "West Africa Time",
    "countryCode": "TD"
  },
  {
    "name": "America/Punta_Arenas",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "CLST",
    "tzName": "Chile Summer Time",
    "countryCode": "CL"
  },
  {
    "name": "America/Santiago",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "CLST",
    "tzName": "Chile Summer Time",
    "countryCode": "CL"
  },
  {
    "name": "Pacific/Easter",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EASST",
    "tzName": "Easter Island Summer Time",
    "countryCode": "CL"
  },
  {
    "name": "America/Coyhaique",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "CLST",
    "tzName": "Chile Summer Time",
    "countryCode": "CL"
  },
  {
    "name": "Asia/Shanghai",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "CST",
    "tzName": "China Standard Time",
    "countryCode": "CN"
  },
  {
    "name": "Asia/Urumqi",
    "offset": 21600,
    "offset_name": "UTC+06:00",
    "abbreviation": "XJT",
    "tzName": "China Standard Time",
    "countryCode": "CN"
  },
  {
    "name": "Indian/Christmas",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "CXT",
    "tzName": "Christmas Island Time",
    "countryCode": "CX"
  },
  {
    "name": "Indian/Cocos",
    "offset": 23400,
    "offset_name": "UTC+06:30",
    "abbreviation": "CCT",
    "tzName": "Cocos Islands Time",
    "countryCode": "CC"
  },
  {
    "name": "America/Bogota",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "COT",
    "tzName": "Colombia Time",
    "countryCode": "CO"
  },
  {
    "name": "Indian/Comoro",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "EAT",
    "tzName": "East Africa Time",
    "countryCode": "KM"
  },
  {
    "name": "Africa/Brazzaville",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WAT",
    "tzName": "West Africa Time",
    "countryCode": "CG"
  },
  {
    "name": "Pacific/Rarotonga",
    "offset": -36000,
    "offset_name": "UTC-10:00",
    "abbreviation": "CKT",
    "tzName": "Cook Island Time",
    "countryCode": "CK"
  },
  {
    "name": "America/Costa_Rica",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "CR"
  },
  {
    "name": "Europe/Zagreb",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "HR"
  },
  {
    "name": "America/Havana",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "CST",
    "tzName": "Cuba Standard Time",
    "countryCode": "CU"
  },
  {
    "name": "America/Curacao",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "CW"
  },
  {
    "name": "Asia/Famagusta",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "CY"
  },
  {
    "name": "Asia/Nicosia",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "CY"
  },
  {
    "name": "Europe/Prague",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "CZ"
  },
  {
    "name": "Africa/Kinshasa",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WAT",
    "tzName": "West Africa Time",
    "countryCode": "CD"
  },
  {
    "name": "Africa/Lubumbashi",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "CAT",
    "tzName": "Central Africa Time",
    "countryCode": "CD"
  },
  {
    "name": "Europe/Copenhagen",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "DK"
  },
  {
    "name": "Africa/Djibouti",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "EAT",
    "tzName": "East Africa Time",
    "countryCode": "DJ"
  },
  {
    "name": "America/Dominica",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "DM"
  },
  {
    "name": "America/Santo_Domingo",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "DO"
  },
  {
    "name": "America/Guayaquil",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "ECT",
    "tzName": "Ecuador Time",
    "countryCode": "EC"
  },
  {
    "name": "Pacific/Galapagos",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "GALT",
    "tzName": "Galápagos Time",
    "countryCode": "EC"
  },
  {
    "name": "Africa/Cairo",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "EG"
  },
  {
    "name": "America/El_Salvador",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "SV"
  },
  {
    "name": "Africa/Malabo",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WAT",
    "tzName": "West Africa Time",
    "countryCode": "GQ"
  },
  {
    "name": "Africa/Asmara",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "EAT",
    "tzName": "East Africa Time",
    "countryCode": "ER"
  },
  {
    "name": "Europe/Tallinn",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "EE"
  },
  {
    "name": "Africa/Mbabane",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "SAST",
    "tzName": "South African Standard Time",
    "countryCode": "SZ"
  },
  {
    "name": "Africa/Addis_Ababa",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "EAT",
    "tzName": "East Africa Time",
    "countryCode": "ET"
  },
  {
    "name": "Atlantic/Stanley",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "FKST",
    "tzName": "Falkland Islands Summer Time",
    "countryCode": "FK"
  },
  {
    "name": "Atlantic/Faroe",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "WET",
    "tzName": "Western European Time",
    "countryCode": "FO"
  },
  {
    "name": "Pacific/Fiji",
    "offset": 43200,
    "offset_name": "UTC+12:00",
    "abbreviation": "FJT",
    "tzName": "Fiji Time",
    "countryCode": "FJ"
  },
  {
    "name": "Europe/Helsinki",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "FI"
  },
  {
    "name": "Europe/Paris",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "FR"
  },
  {
    "name": "America/Cayenne",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "GFT",
    "tzName": "French Guiana Time",
    "countryCode": "GF"
  },
  {
    "name": "Pacific/Gambier",
    "offset": -32400,
    "offset_name": "UTC-09:00",
    "abbreviation": "GAMT",
    "tzName": "Gambier Islands Time",
    "countryCode": "PF"
  },
  {
    "name": "Pacific/Marquesas",
    "offset": -34200,
    "offset_name": "UTC-09:30",
    "abbreviation": "MART",
    "tzName": "Marquesas Islands Time",
    "countryCode": "PF"
  },
  {
    "name": "Pacific/Tahiti",
    "offset": -36000,
    "offset_name": "UTC-10:00",
    "abbreviation": "TAHT",
    "tzName": "Tahiti Time",
    "countryCode": "PF"
  },
  {
    "name": "Indian/Kerguelen",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "TFT",
    "tzName": "French Southern and Antarctic Time",
    "countryCode": "TF"
  },
  {
    "name": "Africa/Libreville",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WAT",
    "tzName": "West Africa Time",
    "countryCode": "GA"
  },
  {
    "name": "Asia/Tbilisi",
    "offset": 14400,
    "offset_name": "UTC+04:00",
    "abbreviation": "GET",
    "tzName": "Georgia Standard Time",
    "countryCode": "GE"
  },
  {
    "name": "Europe/Berlin",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "DE"
  },
  {
    "name": "Europe/Busingen",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "DE"
  },
  {
    "name": "Africa/Accra",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "GH"
  },
  {
    "name": "Europe/Gibraltar",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "GI"
  },
  {
    "name": "Europe/Athens",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "GR"
  },
  {
    "name": "America/Danmarkshavn",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "GL"
  },
  {
    "name": "America/Nuuk",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "WGT",
    "tzName": "West Greenland Time",
    "countryCode": "GL"
  },
  {
    "name": "America/Scoresbysund",
    "offset": -3600,
    "offset_name": "UTC-01:00",
    "abbreviation": "EGT",
    "tzName": "Eastern Greenland Time",
    "countryCode": "GL"
  },
  {
    "name": "America/Thule",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "GL"
  },
  {
    "name": "America/Grenada",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "GD"
  },
  {
    "name": "America/Guadeloupe",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "GP"
  },
  {
    "name": "Pacific/Guam",
    "offset": 36000,
    "offset_name": "UTC+10:00",
    "abbreviation": "CHST",
    "tzName": "Chamorro Standard Time",
    "countryCode": "GU"
  },
  {
    "name": "America/Guatemala",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "GT"
  },
  {
    "name": "Europe/Guernsey",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "GG"
  },
  {
    "name": "Africa/Conakry",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "GN"
  },
  {
    "name": "Africa/Bissau",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "GW"
  },
  {
    "name": "America/Guyana",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "GYT",
    "tzName": "Guyana Time",
    "countryCode": "GY"
  },
  {
    "name": "America/Port-au-Prince",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "HT"
  },
  {
    "name": "Indian/Kerguelen",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "TFT",
    "tzName": "French Southern and Antarctic Time",
    "countryCode": "HM"
  },
  {
    "name": "America/Tegucigalpa",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "HN"
  },
  {
    "name": "Asia/Hong_Kong",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "HKT",
    "tzName": "Hong Kong Time",
    "countryCode": "HK"
  },
  {
    "name": "Europe/Budapest",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "HU"
  },
  {
    "name": "Atlantic/Reykjavik",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "IS"
  },
  {
    "name": "Asia/Kolkata",
    "offset": 19800,
    "offset_name": "UTC+05:30",
    "abbreviation": "IST",
    "tzName": "Indian Standard Time",
    "countryCode": "IN"
  },
  {
    "name": "Asia/Jakarta",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "WIB",
    "tzName": "Western Indonesian Time",
    "countryCode": "ID"
  },
  {
    "name": "Asia/Jayapura",
    "offset": 32400,
    "offset_name": "UTC+09:00",
    "abbreviation": "WIT",
    "tzName": "Eastern Indonesian Time",
    "countryCode": "ID"
  },
  {
    "name": "Asia/Makassar",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "WITA",
    "tzName": "Central Indonesia Time",
    "countryCode": "ID"
  },
  {
    "name": "Asia/Pontianak",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "WIB",
    "tzName": "Western Indonesian Time",
    "countryCode": "ID"
  },
  {
    "name": "Asia/Tehran",
    "offset": 12600,
    "offset_name": "UTC+03:30",
    "abbreviation": "IRDT",
    "tzName": "Iran Daylight Time",
    "countryCode": "IR"
  },
  {
    "name": "Asia/Baghdad",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "AST",
    "tzName": "Arabia Standard Time",
    "countryCode": "IQ"
  },
  {
    "name": "Europe/Dublin",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "IE"
  },
  {
    "name": "Asia/Jerusalem",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "IST",
    "tzName": "Israel Standard Time",
    "countryCode": "IL"
  },
  {
    "name": "Europe/Rome",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "IT"
  },
  {
    "name": "Africa/Abidjan",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "CI"
  },
  {
    "name": "America/Jamaica",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "JM"
  },
  {
    "name": "Asia/Tokyo",
    "offset": 32400,
    "offset_name": "UTC+09:00",
    "abbreviation": "JST",
    "tzName": "Japan Standard Time",
    "countryCode": "JP"
  },
  {
    "name": "Europe/Jersey",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "JE"
  },
  {
    "name": "Asia/Amman",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "JO"
  },
  {
    "name": "Asia/Almaty",
    "offset": 21600,
    "offset_name": "UTC+06:00",
    "abbreviation": "ALMT",
    "tzName": "Alma-Ata Time[1",
    "countryCode": "KZ"
  },
  {
    "name": "Asia/Aqtau",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "AQTT",
    "tzName": "Aqtobe Time",
    "countryCode": "KZ"
  },
  {
    "name": "Asia/Aqtobe",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "AQTT",
    "tzName": "Aqtobe Time",
    "countryCode": "KZ"
  },
  {
    "name": "Asia/Atyrau",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "MSD+1",
    "tzName": "Moscow Daylight Time+1",
    "countryCode": "KZ"
  },
  {
    "name": "Asia/Oral",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "ORAT",
    "tzName": "Oral Time",
    "countryCode": "KZ"
  },
  {
    "name": "Asia/Qostanay",
    "offset": 21600,
    "offset_name": "UTC+06:00",
    "abbreviation": "QYZST",
    "tzName": "Qyzylorda Summer Time",
    "countryCode": "KZ"
  },
  {
    "name": "Asia/Qyzylorda",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "QYZT",
    "tzName": "Qyzylorda Summer Time",
    "countryCode": "KZ"
  },
  {
    "name": "Africa/Nairobi",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "EAT",
    "tzName": "East Africa Time",
    "countryCode": "KE"
  },
  {
    "name": "Pacific/Enderbury",
    "offset": 46800,
    "offset_name": "UTC+13:00",
    "abbreviation": "PHOT",
    "tzName": "Phoenix Island Time",
    "countryCode": "KI"
  },
  {
    "name": "Pacific/Kiritimati",
    "offset": 50400,
    "offset_name": "UTC+14:00",
    "abbreviation": "LINT",
    "tzName": "Line Islands Time",
    "countryCode": "KI"
  },
  {
    "name": "Pacific/Tarawa",
    "offset": 43200,
    "offset_name": "UTC+12:00",
    "abbreviation": "GILT",
    "tzName": "Gilbert Island Time",
    "countryCode": "KI"
  },
  {
    "name": "Europe/Belgrade",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "XK"
  },
  {
    "name": "Asia/Kuwait",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "AST",
    "tzName": "Arabia Standard Time",
    "countryCode": "KW"
  },
  {
    "name": "Asia/Bishkek",
    "offset": 21600,
    "offset_name": "UTC+06:00",
    "abbreviation": "KGT",
    "tzName": "Kyrgyzstan Time",
    "countryCode": "KG"
  },
  {
    "name": "Asia/Vientiane",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "ICT",
    "tzName": "Indochina Time",
    "countryCode": "LA"
  },
  {
    "name": "Europe/Riga",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "LV"
  },
  {
    "name": "Asia/Beirut",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "LB"
  },
  {
    "name": "Africa/Maseru",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "SAST",
    "tzName": "South African Standard Time",
    "countryCode": "LS"
  },
  {
    "name": "Africa/Monrovia",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "LR"
  },
  {
    "name": "Africa/Tripoli",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "LY"
  },
  {
    "name": "Europe/Vaduz",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "LI"
  },
  {
    "name": "Europe/Vilnius",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "LT"
  },
  {
    "name": "Europe/Luxembourg",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "LU"
  },
  {
    "name": "Asia/Macau",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "CST",
    "tzName": "China Standard Time",
    "countryCode": "MO"
  },
  {
    "name": "Indian/Antananarivo",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "EAT",
    "tzName": "East Africa Time",
    "countryCode": "MG"
  },
  {
    "name": "Africa/Blantyre",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "CAT",
    "tzName": "Central Africa Time",
    "countryCode": "MW"
  },
  {
    "name": "Asia/Kuala_Lumpur",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "MYT",
    "tzName": "Malaysia Time",
    "countryCode": "MY"
  },
  {
    "name": "Asia/Kuching",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "MYT",
    "tzName": "Malaysia Time",
    "countryCode": "MY"
  },
  {
    "name": "Indian/Maldives",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "MVT",
    "tzName": "Maldives Time",
    "countryCode": "MV"
  },
  {
    "name": "Africa/Bamako",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "ML"
  },
  {
    "name": "Europe/Malta",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "MT"
  },
  {
    "name": "Europe/Isle_of_Man",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "IM"
  },
  {
    "name": "Pacific/Kwajalein",
    "offset": 43200,
    "offset_name": "UTC+12:00",
    "abbreviation": "MHT",
    "tzName": "Marshall Islands Time",
    "countryCode": "MH"
  },
  {
    "name": "Pacific/Majuro",
    "offset": 43200,
    "offset_name": "UTC+12:00",
    "abbreviation": "MHT",
    "tzName": "Marshall Islands Time",
    "countryCode": "MH"
  },
  {
    "name": "America/Martinique",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "MQ"
  },
  {
    "name": "Africa/Nouakchott",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "MR"
  },
  {
    "name": "Indian/Mauritius",
    "offset": 14400,
    "offset_name": "UTC+04:00",
    "abbreviation": "MUT",
    "tzName": "Mauritius Time",
    "countryCode": "MU"
  },
  {
    "name": "Indian/Mayotte",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "EAT",
    "tzName": "East Africa Time",
    "countryCode": "YT"
  },
  {
    "name": "America/Bahia_Banderas",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "MX"
  },
  {
    "name": "America/Cancun",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "MX"
  },
  {
    "name": "America/Chihuahua",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "MX"
  },
  {
    "name": "America/Hermosillo",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "MX"
  },
  {
    "name": "America/Matamoros",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "MX"
  },
  {
    "name": "America/Mazatlan",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "MX"
  },
  {
    "name": "America/Merida",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "MX"
  },
  {
    "name": "America/Mexico_City",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "MX"
  },
  {
    "name": "America/Monterrey",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "MX"
  },
  {
    "name": "America/Ojinaga",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "MX"
  },
  {
    "name": "America/Tijuana",
    "offset": -28800,
    "offset_name": "UTC-08:00",
    "abbreviation": "PST",
    "tzName": "Pacific Standard Time (North America)",
    "countryCode": "MX"
  },
  {
    "name": "America/Ciudad_Juarez",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "MX"
  },
  {
    "name": "Pacific/Chuuk",
    "offset": 36000,
    "offset_name": "UTC+10:00",
    "abbreviation": "CHUT",
    "tzName": "Chuuk Time",
    "countryCode": "FM"
  },
  {
    "name": "Pacific/Kosrae",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "KOST",
    "tzName": "Kosrae Time",
    "countryCode": "FM"
  },
  {
    "name": "Pacific/Pohnpei",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "PONT",
    "tzName": "Pohnpei Standard Time",
    "countryCode": "FM"
  },
  {
    "name": "Europe/Chisinau",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "MD"
  },
  {
    "name": "Europe/Monaco",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "MC"
  },
  {
    "name": "Asia/Choibalsan",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "CHOT",
    "tzName": "Choibalsan Standard Time",
    "countryCode": "MN"
  },
  {
    "name": "Asia/Hovd",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "HOVT",
    "tzName": "Hovd Time",
    "countryCode": "MN"
  },
  {
    "name": "Asia/Ulaanbaatar",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "ULAT",
    "tzName": "Ulaanbaatar Standard Time",
    "countryCode": "MN"
  },
  {
    "name": "Europe/Podgorica",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "ME"
  },
  {
    "name": "America/Montserrat",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "MS"
  },
  {
    "name": "Africa/Casablanca",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WEST",
    "tzName": "Western European Summer Time",
    "countryCode": "MA"
  },
  {
    "name": "Africa/El_Aaiun",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WEST",
    "tzName": "Western Sahara Time",
    "countryCode": "MA"
  },
  {
    "name": "Africa/Maputo",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "CAT",
    "tzName": "Central Africa Time",
    "countryCode": "MZ"
  },
  {
    "name": "Asia/Yangon",
    "offset": 23400,
    "offset_name": "UTC+06:30",
    "abbreviation": "MMT",
    "tzName": "Myanmar Standard Time",
    "countryCode": "MM"
  },
  {
    "name": "Africa/Windhoek",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "WAST",
    "tzName": "West Africa Summer Time",
    "countryCode": "NA"
  },
  {
    "name": "Pacific/Nauru",
    "offset": 43200,
    "offset_name": "UTC+12:00",
    "abbreviation": "NRT",
    "tzName": "Nauru Time",
    "countryCode": "NR"
  },
  {
    "name": "Asia/Kathmandu",
    "offset": 20700,
    "offset_name": "UTC+05:45",
    "abbreviation": "NPT",
    "tzName": "Nepal Time",
    "countryCode": "NP"
  },
  {
    "name": "Europe/Amsterdam",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "NL"
  },
  {
    "name": "Pacific/Noumea",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "NCT",
    "tzName": "New Caledonia Time",
    "countryCode": "NC"
  },
  {
    "name": "Pacific/Auckland",
    "offset": 46800,
    "offset_name": "UTC+13:00",
    "abbreviation": "NZDT",
    "tzName": "New Zealand Daylight Time",
    "countryCode": "NZ"
  },
  {
    "name": "Pacific/Chatham",
    "offset": 49500,
    "offset_name": "UTC+13:45",
    "abbreviation": "CHAST",
    "tzName": "Chatham Standard Time",
    "countryCode": "NZ"
  },
  {
    "name": "America/Managua",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "NI"
  },
  {
    "name": "Africa/Niamey",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WAT",
    "tzName": "West Africa Time",
    "countryCode": "NE"
  },
  {
    "name": "Africa/Lagos",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WAT",
    "tzName": "West Africa Time",
    "countryCode": "NG"
  },
  {
    "name": "Pacific/Niue",
    "offset": -39600,
    "offset_name": "UTC-11:00",
    "abbreviation": "NUT",
    "tzName": "Niue Time",
    "countryCode": "NU"
  },
  {
    "name": "Pacific/Norfolk",
    "offset": 43200,
    "offset_name": "UTC+12:00",
    "abbreviation": "NFT",
    "tzName": "Norfolk Time",
    "countryCode": "NF"
  },
  {
    "name": "Asia/Pyongyang",
    "offset": 32400,
    "offset_name": "UTC+09:00",
    "abbreviation": "KST",
    "tzName": "Korea Standard Time",
    "countryCode": "KP"
  },
  {
    "name": "Europe/Skopje",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "MK"
  },
  {
    "name": "Pacific/Saipan",
    "offset": 36000,
    "offset_name": "UTC+10:00",
    "abbreviation": "ChST",
    "tzName": "Chamorro Standard Time",
    "countryCode": "MP"
  },
  {
    "name": "Europe/Oslo",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "NO"
  },
  {
    "name": "Arctic/Longyearbyen",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "NO"
  },
  {
    "name": "Asia/Muscat",
    "offset": 14400,
    "offset_name": "UTC+04:00",
    "abbreviation": "GST",
    "tzName": "Gulf Standard Time",
    "countryCode": "OM"
  },
  {
    "name": "Asia/Karachi",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "PKT",
    "tzName": "Pakistan Standard Time",
    "countryCode": "PK"
  },
  {
    "name": "Pacific/Palau",
    "offset": 32400,
    "offset_name": "UTC+09:00",
    "abbreviation": "PWT",
    "tzName": "Palau Time",
    "countryCode": "PW"
  },
  {
    "name": "Asia/Gaza",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "PS"
  },
  {
    "name": "Asia/Hebron",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "PS"
  },
  {
    "name": "America/Panama",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "PA"
  },
  {
    "name": "Pacific/Bougainville",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "BST",
    "tzName": "Bougainville Standard Time[6",
    "countryCode": "PG"
  },
  {
    "name": "Pacific/Port_Moresby",
    "offset": 36000,
    "offset_name": "UTC+10:00",
    "abbreviation": "PGT",
    "tzName": "Papua New Guinea Time",
    "countryCode": "PG"
  },
  {
    "name": "America/Asuncion",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "PYST",
    "tzName": "Paraguay Summer Time",
    "countryCode": "PY"
  },
  {
    "name": "America/Lima",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "PET",
    "tzName": "Peru Time",
    "countryCode": "PE"
  },
  {
    "name": "Asia/Manila",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "PHT",
    "tzName": "Philippine Time",
    "countryCode": "PH"
  },
  {
    "name": "Pacific/Pitcairn",
    "offset": -28800,
    "offset_name": "UTC-08:00",
    "abbreviation": "PST",
    "tzName": "Pacific Standard Time (North America)",
    "countryCode": "PN"
  },
  {
    "name": "Europe/Warsaw",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "PL"
  },
  {
    "name": "Atlantic/Azores",
    "offset": -3600,
    "offset_name": "UTC-01:00",
    "abbreviation": "AZOT",
    "tzName": "Azores Standard Time",
    "countryCode": "PT"
  },
  {
    "name": "Atlantic/Madeira",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "WET",
    "tzName": "Western European Time",
    "countryCode": "PT"
  },
  {
    "name": "Europe/Lisbon",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "WET",
    "tzName": "Western European Time",
    "countryCode": "PT"
  },
  {
    "name": "America/Puerto_Rico",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "PR"
  },
  {
    "name": "Asia/Qatar",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "AST",
    "tzName": "Arabia Standard Time",
    "countryCode": "QA"
  },
  {
    "name": "Indian/Reunion",
    "offset": 14400,
    "offset_name": "UTC+04:00",
    "abbreviation": "RET",
    "tzName": "Réunion Time",
    "countryCode": "RE"
  },
  {
    "name": "Europe/Bucharest",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "RO"
  },
  {
    "name": "Asia/Anadyr",
    "offset": 43200,
    "offset_name": "UTC+12:00",
    "abbreviation": "ANAT",
    "tzName": "Anadyr Time[4",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Barnaul",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "KRAT",
    "tzName": "Krasnoyarsk Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Chita",
    "offset": 32400,
    "offset_name": "UTC+09:00",
    "abbreviation": "YAKT",
    "tzName": "Yakutsk Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Irkutsk",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "IRKT",
    "tzName": "Irkutsk Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Kamchatka",
    "offset": 43200,
    "offset_name": "UTC+12:00",
    "abbreviation": "PETT",
    "tzName": "Kamchatka Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Khandyga",
    "offset": 32400,
    "offset_name": "UTC+09:00",
    "abbreviation": "YAKT",
    "tzName": "Yakutsk Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Krasnoyarsk",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "KRAT",
    "tzName": "Krasnoyarsk Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Magadan",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "MAGT",
    "tzName": "Magadan Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Novokuznetsk",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "KRAT",
    "tzName": "Krasnoyarsk Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Novosibirsk",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "NOVT",
    "tzName": "Novosibirsk Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Omsk",
    "offset": 21600,
    "offset_name": "UTC+06:00",
    "abbreviation": "OMST",
    "tzName": "Omsk Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Sakhalin",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "SAKT",
    "tzName": "Sakhalin Island Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Srednekolymsk",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "SRET",
    "tzName": "Srednekolymsk Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Tomsk",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "MSD+3",
    "tzName": "Moscow Daylight Time+3",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Ust-Nera",
    "offset": 36000,
    "offset_name": "UTC+10:00",
    "abbreviation": "VLAT",
    "tzName": "Vladivostok Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Vladivostok",
    "offset": 36000,
    "offset_name": "UTC+10:00",
    "abbreviation": "VLAT",
    "tzName": "Vladivostok Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Yakutsk",
    "offset": 32400,
    "offset_name": "UTC+09:00",
    "abbreviation": "YAKT",
    "tzName": "Yakutsk Time",
    "countryCode": "RU"
  },
  {
    "name": "Asia/Yekaterinburg",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "YEKT",
    "tzName": "Yekaterinburg Time",
    "countryCode": "RU"
  },
  {
    "name": "Europe/Astrakhan",
    "offset": 14400,
    "offset_name": "UTC+04:00",
    "abbreviation": "SAMT",
    "tzName": "Samara Time",
    "countryCode": "RU"
  },
  {
    "name": "Europe/Kaliningrad",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "RU"
  },
  {
    "name": "Europe/Kirov",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "MSK",
    "tzName": "Moscow Time",
    "countryCode": "RU"
  },
  {
    "name": "Europe/Moscow",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "MSK",
    "tzName": "Moscow Time",
    "countryCode": "RU"
  },
  {
    "name": "Europe/Samara",
    "offset": 14400,
    "offset_name": "UTC+04:00",
    "abbreviation": "SAMT",
    "tzName": "Samara Time",
    "countryCode": "RU"
  },
  {
    "name": "Europe/Saratov",
    "offset": 14400,
    "offset_name": "UTC+04:00",
    "abbreviation": "MSD",
    "tzName": "Moscow Daylight Time+4",
    "countryCode": "RU"
  },
  {
    "name": "Europe/Ulyanovsk",
    "offset": 14400,
    "offset_name": "UTC+04:00",
    "abbreviation": "SAMT",
    "tzName": "Samara Time",
    "countryCode": "RU"
  },
  {
    "name": "Europe/Volgograd",
    "offset": 14400,
    "offset_name": "UTC+04:00",
    "abbreviation": "MSK",
    "tzName": "Moscow Standard Time",
    "countryCode": "RU"
  },
  {
    "name": "Africa/Kigali",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "CAT",
    "tzName": "Central Africa Time",
    "countryCode": "RW"
  },
  {
    "name": "Atlantic/St_Helena",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "SH"
  },
  {
    "name": "America/St_Kitts",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "KN"
  },
  {
    "name": "America/St_Lucia",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "LC"
  },
  {
    "name": "America/Miquelon",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "PMDT",
    "tzName": "Pierre & Miquelon Daylight Time",
    "countryCode": "PM"
  },
  {
    "name": "America/St_Vincent",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "VC"
  },
  {
    "name": "America/St_Barthelemy",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "BL"
  },
  {
    "name": "America/Marigot",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "MF"
  },
  {
    "name": "Pacific/Apia",
    "offset": 50400,
    "offset_name": "UTC+14:00",
    "abbreviation": "WST",
    "tzName": "West Samoa Time",
    "countryCode": "WS"
  },
  {
    "name": "Europe/San_Marino",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "SM"
  },
  {
    "name": "Africa/Sao_Tome",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "ST"
  },
  {
    "name": "Asia/Riyadh",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "AST",
    "tzName": "Arabia Standard Time",
    "countryCode": "SA"
  },
  {
    "name": "Africa/Dakar",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "SN"
  },
  {
    "name": "Europe/Belgrade",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "RS"
  },
  {
    "name": "Indian/Mahe",
    "offset": 14400,
    "offset_name": "UTC+04:00",
    "abbreviation": "SCT",
    "tzName": "Seychelles Time",
    "countryCode": "SC"
  },
  {
    "name": "Africa/Freetown",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "SL"
  },
  {
    "name": "Asia/Singapore",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "SGT",
    "tzName": "Singapore Time",
    "countryCode": "SG"
  },
  {
    "name": "America/Anguilla",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "SX"
  },
  {
    "name": "Europe/Bratislava",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "SK"
  },
  {
    "name": "Europe/Ljubljana",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "SI"
  },
  {
    "name": "Pacific/Guadalcanal",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "SBT",
    "tzName": "Solomon Islands Time",
    "countryCode": "SB"
  },
  {
    "name": "Africa/Mogadishu",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "EAT",
    "tzName": "East Africa Time",
    "countryCode": "SO"
  },
  {
    "name": "Africa/Johannesburg",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "SAST",
    "tzName": "South African Standard Time",
    "countryCode": "ZA"
  },
  {
    "name": "Atlantic/South_Georgia",
    "offset": -7200,
    "offset_name": "UTC-02:00",
    "abbreviation": "GST",
    "tzName": "South Georgia and the South Sandwich Islands Time",
    "countryCode": "GS"
  },
  {
    "name": "Asia/Seoul",
    "offset": 32400,
    "offset_name": "UTC+09:00",
    "abbreviation": "KST",
    "tzName": "Korea Standard Time",
    "countryCode": "KR"
  },
  {
    "name": "Africa/Juba",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "EAT",
    "tzName": "East Africa Time",
    "countryCode": "SS"
  },
  {
    "name": "Africa/Ceuta",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "ES"
  },
  {
    "name": "Atlantic/Canary",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "WET",
    "tzName": "Western European Time",
    "countryCode": "ES"
  },
  {
    "name": "Europe/Madrid",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "ES"
  },
  {
    "name": "Asia/Colombo",
    "offset": 19800,
    "offset_name": "UTC+05:30",
    "abbreviation": "IST",
    "tzName": "Indian Standard Time",
    "countryCode": "LK"
  },
  {
    "name": "Africa/Khartoum",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EAT",
    "tzName": "Eastern African Time",
    "countryCode": "SD"
  },
  {
    "name": "America/Paramaribo",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "SRT",
    "tzName": "Suriname Time",
    "countryCode": "SR"
  },
  {
    "name": "Arctic/Longyearbyen",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "SJ"
  },
  {
    "name": "Europe/Stockholm",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "SE"
  },
  {
    "name": "Europe/Zurich",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "CH"
  },
  {
    "name": "Asia/Damascus",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "SY"
  },
  {
    "name": "Asia/Taipei",
    "offset": 28800,
    "offset_name": "UTC+08:00",
    "abbreviation": "CST",
    "tzName": "China Standard Time",
    "countryCode": "TW"
  },
  {
    "name": "Asia/Dushanbe",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "TJT",
    "tzName": "Tajikistan Time",
    "countryCode": "TJ"
  },
  {
    "name": "Africa/Dar_es_Salaam",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "EAT",
    "tzName": "East Africa Time",
    "countryCode": "TZ"
  },
  {
    "name": "Asia/Bangkok",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "ICT",
    "tzName": "Indochina Time",
    "countryCode": "TH"
  },
  {
    "name": "America/Nassau",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America)",
    "countryCode": "BS"
  },
  {
    "name": "Africa/Banjul",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "GM"
  },
  {
    "name": "Asia/Dili",
    "offset": 32400,
    "offset_name": "UTC+09:00",
    "abbreviation": "TLT",
    "tzName": "Timor Leste Time",
    "countryCode": "TL"
  },
  {
    "name": "Africa/Lome",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "TG"
  },
  {
    "name": "Pacific/Fakaofo",
    "offset": 46800,
    "offset_name": "UTC+13:00",
    "abbreviation": "TKT",
    "tzName": "Tokelau Time",
    "countryCode": "TK"
  },
  {
    "name": "Pacific/Tongatapu",
    "offset": 46800,
    "offset_name": "UTC+13:00",
    "abbreviation": "TOT",
    "tzName": "Tonga Time",
    "countryCode": "TO"
  },
  {
    "name": "America/Port_of_Spain",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "TT"
  },
  {
    "name": "Africa/Tunis",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "TN"
  },
  {
    "name": "Europe/Istanbul",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "TR"
  },
  {
    "name": "Asia/Ashgabat",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "TMT",
    "tzName": "Turkmenistan Time",
    "countryCode": "TM"
  },
  {
    "name": "America/Grand_Turk",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "TC"
  },
  {
    "name": "Pacific/Funafuti",
    "offset": 43200,
    "offset_name": "UTC+12:00",
    "abbreviation": "TVT",
    "tzName": "Tuvalu Time",
    "countryCode": "TV"
  },
  {
    "name": "Africa/Kampala",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "EAT",
    "tzName": "East Africa Time",
    "countryCode": "UG"
  },
  {
    "name": "Europe/Kyiv",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "UA"
  },
  {
    "name": "Europe/Simferopol",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "MSK",
    "tzName": "Moscow Time",
    "countryCode": "UA"
  },
  {
    "name": "Europe/Uzhgorod",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "UA"
  },
  {
    "name": "Europe/Zaporozhye",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "EET",
    "tzName": "Eastern European Time",
    "countryCode": "UA"
  },
  {
    "name": "Asia/Dubai",
    "offset": 14400,
    "offset_name": "UTC+04:00",
    "abbreviation": "GST",
    "tzName": "Gulf Standard Time",
    "countryCode": "AE"
  },
  {
    "name": "Europe/London",
    "offset": 0,
    "offset_name": "UTC±00",
    "abbreviation": "GMT",
    "tzName": "Greenwich Mean Time",
    "countryCode": "GB"
  },
  {
    "name": "America/Adak",
    "offset": -36000,
    "offset_name": "UTC-10:00",
    "abbreviation": "HST",
    "tzName": "Hawaii–Aleutian Standard Time",
    "countryCode": "US"
  },
  {
    "name": "America/Anchorage",
    "offset": -32400,
    "offset_name": "UTC-09:00",
    "abbreviation": "AKST",
    "tzName": "Alaska Standard Time",
    "countryCode": "US"
  },
  {
    "name": "America/Boise",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "US"
  },
  {
    "name": "America/Chicago",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "US"
  },
  {
    "name": "America/Denver",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "US"
  },
  {
    "name": "America/Detroit",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "US"
  },
  {
    "name": "America/Indiana/Indianapolis",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "US"
  },
  {
    "name": "America/Indiana/Knox",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "US"
  },
  {
    "name": "America/Indiana/Marengo",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "US"
  },
  {
    "name": "America/Indiana/Petersburg",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "US"
  },
  {
    "name": "America/Indiana/Tell_City",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "US"
  },
  {
    "name": "America/Indiana/Vevay",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "US"
  },
  {
    "name": "America/Indiana/Vincennes",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "US"
  },
  {
    "name": "America/Indiana/Winamac",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "US"
  },
  {
    "name": "America/Juneau",
    "offset": -32400,
    "offset_name": "UTC-09:00",
    "abbreviation": "AKST",
    "tzName": "Alaska Standard Time",
    "countryCode": "US"
  },
  {
    "name": "America/Kentucky/Louisville",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "US"
  },
  {
    "name": "America/Kentucky/Monticello",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "US"
  },
  {
    "name": "America/Los_Angeles",
    "offset": -28800,
    "offset_name": "UTC-08:00",
    "abbreviation": "PST",
    "tzName": "Pacific Standard Time (North America)",
    "countryCode": "US"
  },
  {
    "name": "America/Menominee",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "US"
  },
  {
    "name": "America/Metlakatla",
    "offset": -32400,
    "offset_name": "UTC-09:00",
    "abbreviation": "AKST",
    "tzName": "Alaska Standard Time",
    "countryCode": "US"
  },
  {
    "name": "America/New_York",
    "offset": -18000,
    "offset_name": "UTC-05:00",
    "abbreviation": "EST",
    "tzName": "Eastern Standard Time (North America",
    "countryCode": "US"
  },
  {
    "name": "America/Nome",
    "offset": -32400,
    "offset_name": "UTC-09:00",
    "abbreviation": "AKST",
    "tzName": "Alaska Standard Time",
    "countryCode": "US"
  },
  {
    "name": "America/North_Dakota/Beulah",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "US"
  },
  {
    "name": "America/North_Dakota/Center",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "US"
  },
  {
    "name": "America/North_Dakota/New_Salem",
    "offset": -21600,
    "offset_name": "UTC-06:00",
    "abbreviation": "CST",
    "tzName": "Central Standard Time (North America)",
    "countryCode": "US"
  },
  {
    "name": "America/Phoenix",
    "offset": -25200,
    "offset_name": "UTC-07:00",
    "abbreviation": "MST",
    "tzName": "Mountain Standard Time (North America)",
    "countryCode": "US"
  },
  {
    "name": "America/Sitka",
    "offset": -32400,
    "offset_name": "UTC-09:00",
    "abbreviation": "AKST",
    "tzName": "Alaska Standard Time",
    "countryCode": "US"
  },
  {
    "name": "America/Yakutat",
    "offset": -32400,
    "offset_name": "UTC-09:00",
    "abbreviation": "AKST",
    "tzName": "Alaska Standard Time",
    "countryCode": "US"
  },
  {
    "name": "Pacific/Honolulu",
    "offset": -36000,
    "offset_name": "UTC-10:00",
    "abbreviation": "HST",
    "tzName": "Hawaii–Aleutian Standard Time",
    "countryCode": "US"
  },
  {
    "name": "Pacific/Midway",
    "offset": -39600,
    "offset_name": "UTC-11:00",
    "abbreviation": "SST",
    "tzName": "Samoa Standard Time",
    "countryCode": "UM"
  },
  {
    "name": "Pacific/Wake",
    "offset": 43200,
    "offset_name": "UTC+12:00",
    "abbreviation": "WAKT",
    "tzName": "Wake Island Time",
    "countryCode": "UM"
  },
  {
    "name": "America/Montevideo",
    "offset": -10800,
    "offset_name": "UTC-03:00",
    "abbreviation": "UYT",
    "tzName": "Uruguay Standard Time",
    "countryCode": "UY"
  },
  {
    "name": "Asia/Samarkand",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "UZT",
    "tzName": "Uzbekistan Time",
    "countryCode": "UZ"
  },
  {
    "name": "Asia/Tashkent",
    "offset": 18000,
    "offset_name": "UTC+05:00",
    "abbreviation": "UZT",
    "tzName": "Uzbekistan Time",
    "countryCode": "UZ"
  },
  {
    "name": "Pacific/Efate",
    "offset": 39600,
    "offset_name": "UTC+11:00",
    "abbreviation": "VUT",
    "tzName": "Vanuatu Time",
    "countryCode": "VU"
  },
  {
    "name": "Europe/Vatican",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "CET",
    "tzName": "Central European Time",
    "countryCode": "VA"
  },
  {
    "name": "America/Caracas",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "VET",
    "tzName": "Venezuelan Standard Time",
    "countryCode": "VE"
  },
  {
    "name": "Asia/Ho_Chi_Minh",
    "offset": 25200,
    "offset_name": "UTC+07:00",
    "abbreviation": "ICT",
    "tzName": "Indochina Time",
    "countryCode": "VN"
  },
  {
    "name": "America/Tortola",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "VG"
  },
  {
    "name": "America/St_Thomas",
    "offset": -14400,
    "offset_name": "UTC-04:00",
    "abbreviation": "AST",
    "tzName": "Atlantic Standard Time",
    "countryCode": "VI"
  },
  {
    "name": "Pacific/Wallis",
    "offset": 43200,
    "offset_name": "UTC+12:00",
    "abbreviation": "WFT",
    "tzName": "Wallis & Futuna Time",
    "countryCode": "WF"
  },
  {
    "name": "Africa/El_Aaiun",
    "offset": 3600,
    "offset_name": "UTC+01:00",
    "abbreviation": "WEST",
    "tzName": "Western European Summer Time",
    "countryCode": "EH"
  },
  {
    "name": "Asia/Aden",
    "offset": 10800,
    "offset_name": "UTC+03:00",
    "abbreviation": "AST",
    "tzName": "Arabia Standard Time",
    "countryCode": "YE"
  },
  {
    "name": "Africa/Lusaka",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "CAT",
    "tzName": "Central Africa Time",
    "countryCode": "ZM"
  },
  {
    "name": "Africa/Harare",
    "offset": 7200,
    "offset_name": "UTC+02:00",
    "abbreviation": "CAT",
    "tzName": "Central Africa Time",
    "countryCode": "ZW"
  }
];

export default TIMEZONES;
